import React from 'react';
import {
  Box, SimpleGrid, Stat, StatLabel, StatNumber, StatHelpText,
  StatArrow, Heading, Card, CardBody, CardHeader, Text,
  useColorModeValue, Icon, Flex, Progress, VStack
} from '@chakra-ui/react';
import { 
  MdAssessment, MdPeople, MdAttachMoney, MdTrendingUp,
  MdFolder, MdPendingActions
} from 'react-icons/md';

const DiretoriaComercialDashboard = () => {
  const bgCard = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const iconBg = useColorModeValue('blue.50', 'blue.900');
  const iconColor = useColorModeValue('blue.500', 'blue.200');

  return (
    <Box>
      <Heading size="lg" mb={6} color={textColor}>
        Dashboard - Diretoria Comercial
      </Heading>

      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6} mb={8}>
        <Card bg={bgCard} borderColor={borderColor} borderWidth="1px">
          <CardBody>
            <Flex align="center" justify="space-between">
              <Stat>
                <StatLabel color="gray.500">Total Equipe</StatLabel>
                <StatNumber fontSize="2xl">25</StatNumber>
                <StatHelpText>
                  <StatArrow type="increase" />
                  12% este mês
                </StatHelpText>
              </Stat>
              <Box p={3} borderRadius="xl" bg={iconBg}>
                <Icon as={MdPeople} boxSize={8} color={iconColor} />
              </Box>
            </Flex>
          </CardBody>
        </Card>

        <Card bg={bgCard} borderColor={borderColor} borderWidth="1px">
          <CardBody>
            <Flex align="center" justify="space-between">
              <Stat>
                <StatLabel color="gray.500">Precatórios Ativos</StatLabel>
                <StatNumber fontSize="2xl">1,248</StatNumber>
                <StatHelpText>
                  <StatArrow type="increase" />
                  8.5% crescimento
                </StatHelpText>
              </Stat>
              <Box p={3} borderRadius="xl" bg={iconBg}>
                <Icon as={MdFolder} boxSize={8} color={iconColor} />
              </Box>
            </Flex>
          </CardBody>
        </Card>

        <Card bg={bgCard} borderColor={borderColor} borderWidth="1px">
          <CardBody>
            <Flex align="center" justify="space-between">
              <Stat>
                <StatLabel color="gray.500">Taxa de Conversão</StatLabel>
                <StatNumber fontSize="2xl">24.7%</StatNumber>
                <StatHelpText>
                  <StatArrow type="increase" />
                  2.3% aumento
                </StatHelpText>
              </Stat>
              <Box p={3} borderRadius="xl" bg={iconBg}>
                <Icon as={MdTrendingUp} boxSize={8} color={iconColor} />
              </Box>
            </Flex>
          </CardBody>
        </Card>

        <Card bg={bgCard} borderColor={borderColor} borderWidth="1px">
          <CardBody>
            <Flex align="center" justify="space-between">
              <Stat>
                <StatLabel color="gray.500">Valor Total</StatLabel>
                <StatNumber fontSize="xl">R$ 12.4M</StatNumber>
                <StatHelpText>
                  <StatArrow type="increase" />
                  15% este mês
                </StatHelpText>
              </Stat>
              <Box p={3} borderRadius="xl" bg={iconBg}>
                <Icon as={MdAttachMoney} boxSize={8} color={iconColor} />
              </Box>
            </Flex>
          </CardBody>
        </Card>
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={6}>
        <Card bg={bgCard} borderColor={borderColor} borderWidth="1px">
          <CardHeader>
            <Heading size="md">Performance da Equipe</Heading>
          </CardHeader>
          <CardBody>
            <VStack spacing={4} align="stretch">
              <Box>
                <Flex justify="space-between" mb={2}>
                  <Text fontSize="sm">Gestores Comerciais</Text>
                  <Text fontSize="sm" fontWeight="bold">5 ativos</Text>
                </Flex>
                <Progress value={85} colorScheme="blue" borderRadius="full" />
              </Box>
              <Box>
                <Flex justify="space-between" mb={2}>
                  <Text fontSize="sm">Equipe Comercial</Text>
                  <Text fontSize="sm" fontWeight="bold">20 ativos</Text>
                </Flex>
                <Progress value={75} colorScheme="green" borderRadius="full" />
              </Box>
              <Box>
                <Flex justify="space-between" mb={2}>
                  <Text fontSize="sm">Metas Atingidas</Text>
                  <Text fontSize="sm" fontWeight="bold">68%</Text>
                </Flex>
                <Progress value={68} colorScheme="purple" borderRadius="full" />
              </Box>
            </VStack>
          </CardBody>
        </Card>

        <Card bg={bgCard} borderColor={borderColor} borderWidth="1px">
          <CardHeader>
            <Heading size="md">Atividades Recentes</Heading>
          </CardHeader>
          <CardBody>
            <VStack spacing={3} align="stretch">
              <Flex align="center" p={3} bg={useColorModeValue('gray.50', 'gray.900')} borderRadius="md">
                <Icon as={MdPendingActions} boxSize={5} color="orange.500" mr={3} />
                <Box flex="1">
                  <Text fontSize="sm" fontWeight="medium">15 novos precatórios designados</Text>
                  <Text fontSize="xs" color="gray.500">Há 2 horas</Text>
                </Box>
              </Flex>
              <Flex align="center" p={3} bg={useColorModeValue('gray.50', 'gray.900')} borderRadius="md">
                <Icon as={MdAssessment} boxSize={5} color="green.500" mr={3} />
                <Box flex="1">
                  <Text fontSize="sm" fontWeight="medium">Relatório semanal disponível</Text>
                  <Text fontSize="xs" color="gray.500">Há 5 horas</Text>
                </Box>
              </Flex>
              <Flex align="center" p={3} bg={useColorModeValue('gray.50', 'gray.900')} borderRadius="md">
                <Icon as={MdPeople} boxSize={5} color="blue.500" mr={3} />
                <Box flex="1">
                  <Text fontSize="sm" fontWeight="medium">3 novos membros na equipe</Text>
                  <Text fontSize="xs" color="gray.500">Ontem</Text>
                </Box>
              </Flex>
            </VStack>
          </CardBody>
        </Card>
      </SimpleGrid>
    </Box>
  );
};

export default DiretoriaComercialDashboard;